// 设置storage
export const setStorage = (name, token) => {
    localStorage.setItem(name, token)
}

// 获取storage
export const getStorage = (name) => {
    if (localStorage.getItem(name)) {
        return localStorage.getItem(name)
    }
    return null
}

// 删除storage
export const removeStorage = (name) => {
    if (localStorage.getItem(name)) {
        localStorage.removeItem(name)
    }
}

// 清除storage
export const clearStorage = () => {
    localStorage.clear()
}